import React, {useState, useEffect} from 'react';
import Cookies from 'js-cookie';
import pdfIcon from "../../assets/pdf.png";
import linkedinIcon from "../../assets/linkedin.png";

const translations = {
  en: {
    filesAndLinkedIn: "Files and LinkedIn Url",
    cvNotAvailable: "CV not available",
    motivationLetterNotAvailable: "Motivation letter not available",
    cvFileNotAvailable: "CV file is not available."
  },
  nl: {
    filesAndLinkedIn: "Bestanden en LinkedIn URL",
    cvNotAvailable: "CV niet beschikbaar",
    motivationLetterNotAvailable: "Motivatiebrief niet beschikbaar",
    cvFileNotAvailable: "CV bestand is niet beschikbaar."
  }
};

const FilesSection = ({ report, openPdfModal, setError, isDutch = false }) => {
    const [lang, setLang] = useState(isDutch ? 'nl' : 'en');
    const t = translations[lang];

    useEffect(() => {
        const checkLanguage = () => {
            const cookieIsDutch = Cookies.get('isDutch') === 'true';
            const newLang = cookieIsDutch ? 'nl' : 'en';
            if (newLang !== lang) {
                setLang(newLang);
            }
        };
        checkLanguage();
        const interval = setInterval(checkLanguage, 1000);
        return () => clearInterval(interval);
    }, [lang]);

    const showCV =
        report.CvFile &&
        report.CvFile.filename !== "cv" &&
        report.CvFile.filename !== "no_cv.txt" &&
        report.CvFile.filename !== "no_file.txt";

    const showMotivation =
        report.MLetterFile &&
        report.MLetterFile.filename !== "mLetter" &&
        report.MLetterFile.filename !== "no_motivation_letter.txt" &&
        report.MLetterFile.filename !== "no_file.txt";

    const showLinkedIn =
        report.linkedInURL &&
        report.linkedInURL !== "https://www.linkedin.com/";

    const showAny = showCV || showMotivation || showLinkedIn;

    return (
        <div className="flex flex-col gap-2 animate-text border-top pt-8">
            {showAny && (
                <h2 className="text-xl text-primary font-bold animate-text">
                    {t.filesAndLinkedIn}
                </h2>
            )}
            <div className="flex gap-2 flex-wrap">
                {/* CV Section */}
                {showCV && (
                    <div
                        className="cursor-pointer flex items-center gap-2 border p-2 rounded-md animate-text"
                        onClick={() => {
                            if (report.CvFile && report.CvFile.base64) {
                                openPdfModal(report.CvFile.base64);
                            } else {
                                setError(t.cvFileNotAvailable);
                            }
                        }}
                    >
                        <img src={pdfIcon} alt="cv" className="w-4 h-4" />
                        <p className="truncate ">
                            {report.CvFile ? report.CvFile.filename : t.cvNotAvailable}
                        </p>
                    </div>
                )}

                {/* Motivation Letter Section */}
                {showMotivation && (
                    <div
                        className="cursor-pointer flex items-center gap-2 border p-2 rounded-md animate-text"
                        onClick={() => {
                            if (report.MLetterFile && report.MLetterFile.base64) {
                                openPdfModal(report.MLetterFile.base64);
                            }
                        }}
                    >
                        <img src={pdfIcon} alt="mLetter" className="w-4 h-4" />
                        <p className="truncate">
                            {report.MLetterFile
                                ? report.MLetterFile.filename
                                : t.motivationLetterNotAvailable}
                        </p>
                    </div>
                )}

                {/* LinkedIn Section */}
                {showLinkedIn && (
                    <div className=" cursor-pointer border p-2 rounded-md animate-text">
                        <a
                            href={report.linkedInURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2"
                        >
                            <img src={linkedinIcon} alt="linkedin" className="w-4 h-4" />
                            <p className="truncate">{report.linkedInURL}</p>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FilesSection; 